export type MapCoordinates = { lat: number; lng: number };

function pointFromGeometry(place: { geometry?: { location?: { lat: () => number; lng: () => number } } } | null): MapCoordinates | null {
  const point = place?.geometry?.location;
  if (!point) return null;
  const lat = point.lat();
  const lng = point.lng();
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
}

function placesService(map?: any) {
  const googleMaps = (window as any).google?.maps;
  if (!googleMaps?.places?.PlacesService) {
    throw new Error('Places library is not loaded');
  }
  return new googleMaps.places.PlacesService(map || document.createElement('div'));
}

function placesStatusOk(status: string): boolean {
  const ok = (window as any).google?.maps?.places?.PlacesServiceStatus?.OK;
  return status === ok || status === 'OK';
}

export async function coordinatesFromPlaceId(placeId: string, map?: any): Promise<MapCoordinates | null> {
  const id = String(placeId || '').trim();
  if (!id) return null;
  const service = placesService(map);
  return new Promise((resolve) => {
    service.getDetails({ placeId: id, fields: ['geometry'] }, (place: any, status: string) => {
      resolve(placesStatusOk(status) ? pointFromGeometry(place) : null);
    });
  });
}

export async function coordinatesFromPlaceQuery(query: string, map?: any): Promise<MapCoordinates | null> {
  const text = String(query || '').trim();
  if (!text) return null;
  const service = placesService(map);
  const found = await new Promise<MapCoordinates | null>((resolve) => {
    service.findPlaceFromQuery({ query: text, fields: ['geometry'] }, (results: any[], status: string) => {
      resolve(placesStatusOk(status) ? pointFromGeometry(results?.[0]) : null);
    });
  });
  if (found) return found;
  return new Promise((resolve) => {
    service.textSearch({ query: text }, (results: any[], status: string) => {
      resolve(placesStatusOk(status) ? pointFromGeometry(results?.[0]) : null);
    });
  });
}
